import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { SystemSiteService } from 'app/services/system-site.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-get-a-quote',
  templateUrl: './get-a-quote.component.html',
  styleUrls: ['./get-a-quote.component.scss']
})
export class GetAQuoteComponent {
  closeResult: string;
  submitState: 'pending' | 'success' | 'error' = 'pending';
  getAQuoteForm: UntypedFormGroup;
  sendEmailSubscription: Subscription;
  practitionerTypeSubscription: Subscription = null;
  practitionerTypeData: any = []
  lead: string = '';

  parameterSubscription: Subscription = null;
  queryParamSubscription: Subscription = null;


  constructor(private fb: UntypedFormBuilder, private recaptchaV3Service: ReCaptchaV3Service, private systemSiteService: SystemSiteService, private modalService: NgbModal, private router: Router, private route: ActivatedRoute) {

    this.getAQuoteForm = this.fb.group(
      {
        website: [''],
        practice_number: ['', Validators.required],
        first_name: ['', Validators.required],
        last_name: ['', Validators.required],
        email: ['', [Validators.required, Validators.email]],
        mobile: ['', Validators.required],
        message: ['',],
        selected_region: ['', Validators.required],
        number_of_visits: ['', Validators.required],
        average_claim_per_visit: ['', Validators.required],
        interested_package: ['', Validators.required],
        practitioner_speciality: ['', Validators.required],
        is_existing_nedbank_client: [false],
        banker_email: [''],

      }
    )

  }

  get f() {
    return this.getAQuoteForm.controls;
  }

  get isNedbankLead(): boolean {
    return (this.lead || '').toLowerCase() === 'nedbank';
  }

  ngOnInit() {
    var body = document.getElementsByTagName('body')[0];
    body.classList.add('contact-page');
    this.LoadData();

    this.parameterSubscription = this.route.params.subscribe(params => {

      if (params.type) {

        this.getAQuoteForm.patchValue({ "interested_package": params.type })

      }

    });

    this.queryParamSubscription = this.route.queryParams.subscribe(params => {
      if (params.lead) {
        this.lead = params.lead;
        if (this.isNedbankLead) {
          const ctrl = this.getAQuoteForm.get('banker_email');
          ctrl.setValidators([Validators.required, Validators.email]);
          ctrl.updateValueAndValidity();
        }
      }
    });

  }





  LoadData() {
    this.practitionerTypeSubscription = this.systemSiteService.get_practitioner_type().subscribe({
      next: data => {
        //console.log(data.result_data)
        this.practitionerTypeData = data.result_data[0].parmvals;
      },
      error: error => { console.log(error) },
    })





  }



  ngOnDestroy() {
    var body = document.getElementsByTagName('body')[0];
    body.classList.remove('contact-page');

    if (this.sendEmailSubscription)
      this.sendEmailSubscription.unsubscribe();
    if (this.practitionerTypeSubscription)
      this.practitionerTypeSubscription.unsubscribe();
    if (this.queryParamSubscription)
      this.queryParamSubscription.unsubscribe();


  }


  delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async open(content, type) {
    if (type === 'sm') {
      console.log('aici');
      this.modalService.open(content, { size: 'sm' }).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    } else {

      this.submitState = 'pending';

      this.modalService.open(content).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });

      let formValues = this.getAQuoteForm.getRawValue();
      formValues.lead = this.lead;

      this.sendEmailSubscription = this.recaptchaV3Service.execute('submit_quote').pipe(
        switchMap((token) => {
          formValues.recaptcha_token = token;
          return this.systemSiteService.contact_form_get_a_quote(formValues);
        })
      ).subscribe({
        next: async () => {
          this.submitState = 'success';
          await this.delay(1500);
          this.modalService.dismissAll();
          this.router.navigate(['']);
        },
        error: (error) => {
          console.log(error);
          this.submitState = 'error';
        },
      })
    }

  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }







}
